import { render } from "./CreateTypeUser.vue?vue&type=template&id=014d464a"
import script from "./CreateTypeUser.vue?vue&type=script&lang=js"
export * from "./CreateTypeUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__